import axios from 'axios';
import { IProductionUnit } from '../../../@types/model/masterData/productionUnit/productionUnit';
import { IProductionUnitUpsert } from '../../../@types/model/masterData/productionUnit/productionUnitUpsert';
import { UpsertTypeEnum } from '../../../@types/enum/upsertType';

export default class ProductionUnitHttpService {
    public static getList = async (lastSyncedTimeUnix : number, signal ?: AbortSignal) : Promise<Array<IProductionUnit>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/ProductionUnit/GetList`, {
            params: {
                lastSyncedTimeUnix,
            },
            signal
        });

        return result.data;
    }

    public static upsert = async (upsert : IProductionUnitUpsert, type : UpsertTypeEnum) : Promise<IProductionUnit> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/ProductionUnit/${type}`, upsert);

        return result.data;
    }

    public static delete = async (id : number) : Promise<void> => {
        return await axios.delete(`${API_URL}/v1/MasterData/ProductionUnit/Delete`, {
            params: { id },
        });
    }
}